import { render, staticRenderFns } from "./SectionFaq.vue?vue&type=template&id=16b9d622&"
import script from "./SectionFaq.vue?vue&type=script&lang=js&"
export * from "./SectionFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports